import { InputAdornment } from '@material-ui/core'
import { AttachMoney } from '@material-ui/icons'
import { RECEIPT_STATE } from 'Constants'

export const RECEIPT_DATA = (data, handleChange, edit, permissions) => {
  const formatDate = (dateString) => {
    if (!dateString) return ''
    const date = new Date(dateString)
    return date.toLocaleDateString('es-AR')
  }
  return [
    {
      class: 'textfield',
      name: 'origen',
      label: 'Origen',
      value: data.origen,
      disabled: true,
      sm: 6,
      xs: 12,
    },
    {
      class: 'textfield',
      name: 'fecha',
      label: 'Fecha creación',
      value: formatDate(data.fecha),
      disabled: true,
      sm: 6,
      xs: 12,
    },
    {
      class: 'textfield',
      name: 'usuario',
      label: 'Usuario',
      value: data.usuario,
      disabled: true,
      sm: 6,
      xs: 12,
    },
    {
      class: 'textfield',
      type: 'text',
      name: 'comprobante',
      label: 'Nº comprobante',
      value: data.comprobante,
      sm: 6,
      xs: 12,
      disabled: true,
      onChange: (e) => {
        handleChange('comprobante', e.target.value)
      },
    },
    {
      class: 'textfield',
      name: 'modalidad',
      label: 'Modalidad',
      value: data.modalidad,
      disabled: true,
      sm: 6,
      xs: 12,
    },
    {
      class: 'textfield',
      label: 'Importe',
      name: 'total',
      value: data.total,
      sm: 6,
      xs: 12,
      disabled: true,
      inputProps: {
        startAdornment: (
          <InputAdornment position="start">
            <AttachMoney />
          </InputAdornment>
        ),
      },
    },
    {
      class: 'autocomplete',
      name: 'estado',
      label: 'Estado',
      options:
        data.estado === 'Borrador'
          ? RECEIPT_STATE.filter((option) => option.label === 'Borrador')
          : RECEIPT_STATE.filter(
              (option) => option.label === 'Borrador' || option.label === 'Registrado'
            ),
      optionValue: 'label',
      optionLabel: `options["label"]`,
      value: data.estado,
      disabled: permissions.changeState ? !edit : true,
      sm: 6,
      xs: 12,
      onChange: (e) => handleChange('estado', e.label),
    },
    {
      class: 'textfield',
      sm: 6,
      xs: 12,
      name: 'observacion',
      label: 'Observación',
      value: data.observacion,
      disabled: !edit,
      onChange: (e) => handleChange('observacion', e.target.value),
    },
  ]
}
